import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { DirectivesModule } from 'src/modules/directives/module';

import { BranchApiService } from './services/branch-api-service';
import { BranchEventPicker } from './components/branch-picker/component';

@NgModule({
  imports: [CommonModule, MaterialModule, DirectivesModule],
  declarations: [BranchEventPicker],
  providers: [BranchApiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [],
})
export class BranchModule {}
